import { useCallback } from 'react';
import { useBestRouteStations } from '../store';

export const useBestPriceStationByStationCode = () => {
  const bestStationPrice = useBestRouteStations();

  return useCallback(
    (stationCode: string) => {
      return (bestStationPrice || []).find((item) => item.stationCode === stationCode);
    },
    [bestStationPrice]
  );
};
